function HeroBlock({ heading, buttonText, image }) {
  return (
    <section className="block hero-block">
      <div className="hero-content">

        <div className="hero-text">
          <h1>{heading || ''}</h1>
          <button className="hero-button">{buttonText || ''}</button>
        </div>

        <div className="hero-image">
          {image && <img src={image} alt="Company" />}
        </div>

      </div>
    </section>
  );
}

export default HeroBlock;
